module.exports = __webpack_public_path__ + "img/relais-&-chateaux-world-oceans-day.c13c023f.jpg";